/*
 * @FileAuthor: ghy
 * @Date: 2023-09-20 19:26:12
 * @Description: 状态管理
 */

const Event = require('../event');

function Status(ext) {
  this.ext = ext;

  this.enable = true;

  this.init();
}

Status.prototype.init = function () {
  Object.keys(Event).forEach((EventName) => {
    const stateItem = Object.create(null);

    stateItem._state = false;
    stateItem._data = null;

    this[Event[EventName]] = stateItem;

    this.defineProtpertyOfStatusItem(stateItem, Event[EventName]);
  });
};

Status.prototype.defineProtpertyOfStatusItem = function (stateItem, eventName) {
  const status = this;

  Object.defineProperties(stateItem, {
    state: {
      get: () => {
        return stateItem._state;
      },
      set: (state) => {
        stateItem._state = state;
        const data = stateItem._data;
        checkEventState(status, eventName, state, data);
      },
    },
    data: {
      get: () => {
        return stateItem._data;
      },
      set: (data) => {
        stateItem._data = data;
      },
    },
  });
};

/** 检测事件状态 */
function checkEventState(status, eventName, state, data) {
  const Ext = status.ext;
  const EventStatus = status;

  // 处理指南针相关事件
  if (state === true && status.enable && Ext[eventName]) {
    Ext[eventName].forEach((cb) => {
      cb(data);
    });
  }
}

module.exports = Status;
